import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SettingsService } from '@app/core/settings/settings.service';
import { first, map, tap } from 'rxjs/operators';
import { CanActivate, CanActivateChild } from '@angular/router';

@Injectable()
export class RedirectToExternalPageGuard implements CanActivate, CanActivateChild {
  constructor(private settingsService: SettingsService) { }

  public canActivate(): Observable<boolean> {
    return this.redirectWhenApplicableObservable();
  }

  public canActivateChild(): Observable<boolean> {
    return this.canActivate();
  }

  private redirectWhenApplicableObservable(): Observable<boolean> {
    return this.settingsService.getSettingsOnce().pipe(
      first(),
      tap((settings) => {
        if (settings.shouldRedirectToExternalUrl()) {
          window.location.href = settings.redirection_url;
        }
      }),
      map(() => true),
    );
  }
}
